export default "__VITE_ASSET__CCZ8kPde__"